export default "__VITE_ASSET__BZsPopmI__"